<template>
  <v-app class="application--is-rtl main-app" app-data="true">

    <NavBar />
    <div class="banner-wrap " >
      <Banner class="pc-banner " :is-hitech="false" />
    </div>

    <personalNav />

    <Nuxt />

    <Footer class="footer-wrap" />
  </v-app>
</template>

<script>
import NavBar from '@/components/NavigationMenu/NavBar'

import personalNav from '@/components/Candidates/NavBar/personalNav'
import Banner from '@/components/Jobs_List/Banner'
import Footer from '@/components/Footer/Footer'
import DeviceDetect from '@/components/mixins/DeviceDetect'
import BrazeUserSetup from '@/components/mixins/BrazeUserSetup';


export default {
  name: 'personalFullWidth',
  mixins: [DeviceDetect, BrazeUserSetup],
  middleware: 'personalPage',
  components: {
    NavBar,
    personalNav,
    Footer,
    Banner,

  },
}
</script>
